import { createContext, useContext, useState, useEffect } from "react";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [currentLang, setCurrentLang] = useState(localStorage.getItem("SA_user_lang")?localStorage.getItem("SA_user_lang") : "It");

  // Sync across browser tabs
  useEffect(() => {
    const handleStorage = (e) => {
      if (e.key === "SA_user_lang") {
        setCurrentLang(e.newValue || "It"); // Update the state with the new language
      }
    };

    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  // Apply language changes
  const updateLanguage = (newLanguage) => {
    setCurrentLang(newLanguage);
    localStorage.setItem("SA_user_lang", newLanguage);

    // Update <html lang="">
    document.documentElement.setAttribute("lang", newLanguage);
  };

  // Ensure <html> is synced on first load
  useEffect(() => {
    document.documentElement.setAttribute("lang", currentLang);
  }, []);

  return (
    <LanguageContext.Provider
      value={{ currentLang, setCurrentLang: updateLanguage }}
    >
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguageStore = () => useContext(LanguageContext);